<template>
  <section ref="root" class="evento-lux">

    <!-- 🌸 FLORES -->
    <img src="@/assets/f.png" class="flor flor-1" alt="" />
    <img src="@/assets/f.png" class="flor flor-2" alt="" />

    <!-- 🌿 RAjhjhjhhjhkjhjjhhjMAS -->
    <img src="@/assets/ramas.png" class="rama rama-izq" alt="" />

    <!-- 🦋 MARIPOSAS -->
    <img src="@/assets/mariposas.png" class="mariposa mariposa-1" alt="" />
    <img src="@/assets/mariposas.png" class="mariposa mariposa-2" alt="" />

    <!-- ===== TARJETA 1: CEREMONIA RELIGIOSA ===== -->
    <article ref="card1" class="card">
      <img class="icono" src="@/assets/10.avif" alt="" />
      <h3 class="titulo-script">Religious Ceremony</h3>
      <p class="hora">12:00 PM</p>
      <p class="lugar">San Miguel Arcangel Catholic Church</p>
      <img
        ref="fotoLugar1"
        src="@/assets/Gemini_Generated_Image_cwru2xcwru2xcwru (1).png"
        alt="Lugar del evento"
        class="foto-lugar"
      />

      <p class="direccion">10746 Juniper St. <br>Los Angeles, California.</p>  

      <a
        class="btn-rosa"
        href="https://maps.app.goo.gl/z74qnw9XfmtDfpxg8"
        target="_blank"
      >
        How to get there?
        <span class="sheen"></span>
      </a>
    </article>

    <!-- RECEPCIÓN ===== -->
    <article ref="card2" class="card">
      <img class="icono" src="@/assets/10.avif" alt="" />
      <h3 class="titulo-script">Reception</h3>
      <p class="hora">5:30 PM</p>
      <p class="lugar">Banquet Hall</p>
      <img
        ref="fotoLugar2"
        src="@/assets/WhatsApp Image 2026-07-11 at 2.53.25 PM.jpeg"
        alt="Lugar del evento"
        class="foto-lugar"
      />

      <p class="direccion">      <strong>GATEWAY CROSSROADS SHOPPING CENTER <br><br></strong>
661 W Redondo Beach Blvd<br>Gardena, California.
      
      <br><br> <strong>Behind STAPLES store</strong></p>  

      <a
        class="btn-rosa"
        href="https://maps.app.goo.gl/qdbVUhDrxpz8nSA87"
        target="_blank"
      >
        How to get there?
        <span class="sheen"></span>
      </a>
    </article>
  </section>

  <div class="lux-escena-final">
    <div class="lux-degradado"></div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'TuComponente',

  setup() {
    const root = ref(null)
    const card1 = ref(null)
    const card2 = ref(null)
    const fotoLugar1 = ref(null)
    const fotoLugar2 = ref(null)

    onMounted(() => {
      const $ = gsap.utils.selector(root.value)

      const flores = ['.flor-1', '.flor-2'].flatMap($)
      const ramas = ['.rama-izq'].flatMap($)
      const mariposas = ['.mariposa-1', '.mariposa-2'].flatMap($)

      // Selectores de textos para cada tarjeta
      const textoCard1 = gsap.utils.selector(card1.value)([
        '.icono',
        '.titulo-script',
        '.hora',
        '.lugar',
        '.direccion',
        '.btn-rosa'
      ])

      const textoCard2 = gsap.utils.selector(card2.value)([
        '.icono',
        '.titulo-script',
        '.hora',
        '.lugar',
        '.direccion',
        '.btn-rosa'
      ])

      // Configuración inicial (Ocultar elementos)
      gsap.set([fotoLugar1.value, fotoLugar2.value], {
        autoAlpha: 0,
        scale: 0.7,
        rotation: -8,
        y: 30
      })

      gsap.set([...flores, ...textoCard1, ...textoCard2], { autoAlpha: 0, y: 28 })
      gsap.set(mariposas, { autoAlpha: 0, scale: 0.6, y: 40 })
      gsap.set(ramas, { autoAlpha: 0, scaleY: 0, transformOrigin: 'top center' })

      // Intersection Observer para disparar la animación
      const io = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) return

        const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

        // 1. Fondos y follaje decorativo
        tl.to(ramas, { autoAlpha: 1, scaleY: 1, duration: 0.9 })
          .to(flores, { autoAlpha: 1, y: 0, stagger: 0.12 }, '-=0.6')
          .to(mariposas, { autoAlpha: 1, y: 0, scale: 1, stagger: 0.12 }, '-=0.5')
          
          // 2. Animación consecutiva: Tarjeta 1 (Ceremonia Religiosa)
          .to(fotoLugar1.value, {
            autoAlpha: 1,
            scale: 1,
            rotation: 0,
            y: 0,
            duration: 0.8,
            ease: 'back.out(1.7)'
          }, '-=0.1')
          .to(textoCard1, { autoAlpha: 1, y: 0, stagger: 0.08 }, '-=0.4')

          // 3. Animación consecutiva: Tarjeta 2 (Recepción)
          .to(fotoLugar2.value, {
            autoAlpha: 1,
            scale: 1,
            rotation: 0,
            y: 0,
            duration: 0.8,
            ease: 'back.out(1.7)'
          }, '-=0.2')
          .to(textoCard2, { autoAlpha: 1, y: 0, stagger: 0.08 }, '-=0.4')

        io.disconnect()
      }, { threshold: 0.25 })

      io.observe(root.value)
    })

    return { 
      root, 
      card1, 
      card2, 
      fotoLugar1, 
      fotoLugar2
    }
  }
}
</script>


<style scoped>


.evento-lux{
  position: relative;   /* 🔑 OBLIGATORIO */
  overflow: visible;    /* 🔑 OBLIGATORIO */
  padding: 28px 18px 64px;
 
  display: grid;
  place-items: center;
}

/* ===== TARJETA ===== */
.card{
  width: min(440px, 92vw);
  background: transparent;
  box-shadow: none;
  border: none !important;
  outline: none;
  padding: 24px 20px 28px;
  text-align: center;
  position: relative;
  z-index: 0;
}

.icono{
  width: 52px;
  margin: 0 auto 10px;
  opacity: .92;
}

.titulo-script{
  font-family: 'britishgruesa', cursive;
  font-size: 56px;
  margin: 4px 0 8px;
}

.hora{
  font-family: 'fa', sans-serif;
  font-size: 24px;
}

.lugar{
  font-family: 'padres', serif;
  font-size: 22px;
  letter-spacing: .14em;
}

.direccion{
  font-family: 'padres', serif;
  font-style: italic;
  font-size: 16px;
  font-weight: 600;
  color: var(--gris);
  margin-bottom: 16px;
}

/* ===== BOTÓN ===== */
.btn-rosa{
  position: relative;
  padding: 11px 20px;
  border-radius: 14px;
  background: #e793b6;
  color: #fff;
  text-decoration: none;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  box-shadow: 0 8px 16px rgba(0,0,0,.12);
}

.btn-rosa .sheen{
  position: absolute;
  top: -30%;
  left: -30%;
  width: 60%;
  height: 160%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,.6), transparent);
  transform: rotate(20deg);
  opacity: 0;
}

/* ===== ESCENA FINAL ===== */
.lux-escena-final{
  width: 100%;
  margin-top: 8px;
}








/* 🌸 FLORES */
.flor{
  position: absolute;
  width: 120px;
  opacity: .9;
  pointer-events: none;
}
.flor-1{ top: 40px; left: -20px; }
.flor-2{ bottom: 40px; right: -20px; }

/* 🌿 RAMAS */
.rama{
  position: absolute;
  top: 0;
  right: -40px;
  width: 180px;
  pointer-events: none;
}
.foto-lugar{
  width: 220px;
  height: 220px;
  object-fit: cover;
  border-radius: 50%;
  display: block;
  margin: 18px auto;
  border: 8px solid rgba(255,255,255,.9);
  box-shadow:
    0 12px 30px rgba(0,0,0,.18),
    0 0 0 2px rgba(124,145,131,.25);
}
/* 🦋 MARIPOSAS */
.mariposa{
  position: absolute;
  width: 42px;
  pointer-events: none;
}
.mariposa-1{ bottom: 120px; left: 30%; }
.mariposa-2{ bottom: 140px; right: 28%; }

/* 🌸 FLORES */
.flor{
  position: absolute;
  width: 120px;
  z-index: 2;
  pointer-events: none;
}
.flor-1{ top: 630px; left: -30px; }
.flor-2{ top: -40px; right: -30px; }

/* 🌿 RAMAS */
.rama{
  position: absolute;
  top: -10px;
  right: -40px;
  width: 100px;
  z-index: 1;
  pointer-events: none;
}

/* 🦋 MARIPOSAS */
.mariposa{
  position: absolute;
  width: 82px;
  z-index: 4;
  pointer-events: none;
}
.mariposa-1{ top: -30px; right: 92%; }
.mariposa-2{ bottom: 140px; right: 90%; }
</style>
